import React, { useState, useEffect } from 'react';
import { getPurchaseOrder, getSinglePurchaseOrder, editPurchaseOrder, deletePurchaseOrder } from '../../services/vm/apiController';
import { useSelector } from 'react-redux';
import { factoryId, loggedInUser } from '../../store/reducers/account_reducer';
import { TABLE_DEFAULT_LIMIT } from '../../util/constant';
import { Table, Modal, Button, Form, FloatingLabel, Row, Col, Alert } from 'react-bootstrap';
import { formatDate } from '../../util/helper';
import { toast, ToastContainer } from 'react-toastify';
import { DeleteIcon, EditIcon, ViewIcon } from './components/icons';
import { Link } from 'react-router-dom';
import moment from 'moment';
import 'react-toastify/dist/ReactToastify.css';
import AlertIcon from '../../img.svg';
import FactoryDropdown from './FactoryDropdown';
import PaginationInPage from '../Pagination';

const PurchaseOrderList = () => {
  let user = useSelector(loggedInUser);
  const [showPurchaseModal, setShowPurchaseModal] = useState(false);
  const [showConfirmModel, setShowConfirmModel] = useState(false);
  const [vehicleNameSearch, setVehicleNameSearch] = useState('');
  const [idToDeleted, setIdToDeleted] = useState('');
  const [vehicleIdToDeleted, setVehicleIdToDeleted] = useState('');
  const [purchaseOrderList, setPurchaseOrderList] = useState([]);
  const [totalRecords, setTotalRecords] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const factoryId_ = useSelector(factoryId);

  const formFields = {
    purchaseNumber: '',
    vehicleName: '',
    amount: '',
    approvedDate: '',
    approvedBy: '',
    file1: '',
    file1Name: '',
    file2: '',
    file2Name: '',
    file3: '',
    file3Name: '',
  };
  const [purchaseOrderForm, setPurchaseOrderForm] = useState(formFields);
  const handleCloseModal = () => {
    setShowPurchaseModal(false);
  };
  const handleCloseConfirmModal = () => {
    setShowConfirmModel(false);
  };

  const handleChangePurchaseOrder = (e) => {
    e.preventDefault();
    let name = e.target.name;
    let value = e.target.value;
    setPurchaseOrderForm({ ...purchaseOrderForm, [name]: value });
  };
  const onChangeDocumentOne = (e) => {
    e.preventDefault();
    const file = e.target.files[0];
    if (file && file.name.match(/\.(exe|apk|bat|cmd|com|dll|jar|msi|py|sh)$/)) {
      e.target.value = ''; // Clear the selected file
      toast.error('Please select a valid file type.', { autoClose: 2000 });
    } else {
      setPurchaseOrderForm({ ...purchaseOrderForm, file1: file || null, file1Name: file?.name || '' });
    }
  };
  const onChangeDocumentTwo = (e) => {
    e.preventDefault();
    const file = e.target.files[0];
    if (file && file.name.match(/\.(exe|apk|bat|cmd|com|dll|jar|msi|py|sh)$/)) {
      e.target.value = ''; // Clear the selected file
      toast.error('Please select a valid file type.', { autoClose: 2000 });
    } else {
      setPurchaseOrderForm({ ...purchaseOrderForm, file2: file || null, file2Name: file?.name || '' });
    }
  };

  const onChangeDocumentThree = (e) => {
    e.preventDefault();
    const file = e.target.files[0];
    if (file && file.name.match(/\.(exe|apk|bat|cmd|com|dll|jar|msi|py|sh)$/)) {
      e.target.value = ''; // Clear the selected file
      toast.error('Please select a valid file type.', { autoClose: 2000 });
    } else {
      setPurchaseOrderForm({ ...purchaseOrderForm, file3: file || null, file3Name: file?.name || '' });
    }
  };

  const getPurchaseOrderList = async (limit = TABLE_DEFAULT_LIMIT, offset = 0, id = 0) => {
    try {
      let condition = {
        name: vehicleNameSearch || '',
      };
      if (user && user.factoryId) {
        condition['factoryId'] = user.factoryId;
      }
      const purchaseOrder = await getPurchaseOrder(offset, limit, condition, id);

      return id === 0
        ? {
            data: (purchaseOrder && purchaseOrder.data.rows) || [],
            totalRecords: (purchaseOrder && purchaseOrder.data && purchaseOrder.data.count) || 0,
          }
        : {
            data: (purchaseOrder && purchaseOrder.data) || [],
          };
    } catch (e) {
      console.error(e);
      return {
        errorMessage: e.message,
      };
    }
  };

  async function getPurchase() {
    const data = await getPurchaseOrderList(TABLE_DEFAULT_LIMIT, currentPage);
    const filteredData = data.data.filter((item) => !item.isDeleted);
    setTotalRecords(data.totalRecords);
    setPurchaseOrderList(filteredData);
  }

  useEffect(() => {
    getPurchase();
  }, [currentPage]);

  const handleShowModal = (event, id) => {
    event.preventDefault();
    const getPurchaseOrder = async () => {
      const PurchaseOrderVal = await getSinglePurchaseOrder(id);
      const hole = PurchaseOrderVal?.data;
      if (hole.approvedDate !== null) hole.approvedDate = moment(hole.approvedDate).format('YYYY-MM-DD');
      hole.file1 = null;
      hole.file2 = null;
      hole.file3 = null;
      delete hole.Quotation;
      delete hole.VehicleRequest;
      setPurchaseOrderForm(hole);
    };
    getPurchaseOrder();
    setShowPurchaseModal(true);
  };

  const handleShowConfirmModal = (e, id, vehicleId) => {
    e.preventDefault();
    setShowConfirmModel(true);
    setIdToDeleted(id);
    setVehicleIdToDeleted(vehicleId);
  };

  const handleRemove = (event, id) => {
    event.preventDefault();
    const deleteVehicle = async () => {
      try {
        const data = await deletePurchaseOrder(id, vehicleIdToDeleted);
        toast.error(data.data);
        getPurchase();
        setShowConfirmModel(false);
      } catch (err) {
        toast.error(err?.response?.data?.data?.message || 'Something went wrong', { autoClose: 3000 });
      }
    };
    deleteVehicle();
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    const formData = new FormData();

    for (var key in purchaseOrderForm) {
      if (key === 'file1' || key === 'file1Name' || key === 'file2' || key === 'file2Name' || key === 'file3' || key === 'file3Name')
        continue;
      formData.append(key, purchaseOrderForm[key]);
    }

    if (purchaseOrderForm.file1 !== null) formData.append('file1', purchaseOrderForm['file1'], purchaseOrderForm.file1Name);
    if (purchaseOrderForm.file2 !== null) formData.append('file2', purchaseOrderForm['file2'], purchaseOrderForm.file2Name);
    if (purchaseOrderForm.file3 !== null) formData.append('file3', purchaseOrderForm['file3'], purchaseOrderForm.file3Name);

    try {
      await editPurchaseOrder(formData, formData.get('id'));
      toast.success('Purchase Order updated successfully');
      setShowPurchaseModal(false);
      getPurchase();
    } catch (err) {
      toast.error(err?.response?.data?.data?.message || 'Something went wrong', { autoClose: 2000 });
    }
  };

  return (
    <React.Fragment>
      <ToastContainer />
      <nav className="" aria-label="breadcrumb">
        <ol className="breadcrumb">
          <li className="breadcrumb-item">
            <a href="/purchase-orders">Purchase Order List</a>
          </li>
        </ol>
      </nav>
      <div className="card top-card">
        <div className="card-body">
          <div className="row">
            <FactoryDropdown onFactoryChange={getPurchase} />
            <div className="form-group col-md-2 col-lg-2">
              <label htmlFor="exampleInputEmail1">Vehicle Name</label>
              <input
                type="text"
                className="form-control"
                id="exampleInputEmail1"
                placeholder="Please enter Vehicle Name"
                value={vehicleNameSearch}
                onChange={(e) => {
                  setVehicleNameSearch(e.target.value);
                }}
              />
            </div>
            <div className="form-group col-md-8 col-lg-8">
              <div className="btn-wrapper justify-content-start cmt-3">
                <button type="button" className="btn app-btn-primary" onClick={getPurchase}>
                  Search
                </button>
                <button
                  type="button"
                  className="btn app-btn-default"
                  onClick={(e) => {
                    setVehicleNameSearch('');
                  }}
                >
                  Reset
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="card">
        <div className="card-header white-color" style={{ padding: '1rem 1.7rem' }}>
          <h4 className="card-title mb-0" style={{ fontSize: '16px' }}>
            Purchase Order | {totalRecords ?? 0}
          </h4>
        </div>
        <div className="card-body px-0 vehicle-requests-table pt-0 pb-0">
          <div className="row">
            <div className="col">
              <Table responsive striped>
                <thead>
                  <tr>
                    <th>#</th>
                    <th>Vehicle Name</th>
                    <th>PO</th>
                    <th>Amount</th>
                    <th>Approved By</th>
                    <th>Vendor Name</th>
                    <th>Approved Date</th>
                    <th>Created Date</th>
                    <th>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {purchaseOrderList.map((request, index) => {
                    return (
                      <tr key={request.id} className={request.isDeleted ? '' : request.status === 'SCRAP-RESELL' ? 'resell-scrap' : ''}>
                        <td>{(currentPage - 1) * TABLE_DEFAULT_LIMIT + (index + 1)}</td>
                        <td>{request?.vehicleName}</td>
                        <td>{request.purchaseNumber}</td>
                        <td>{request?.amount}</td>
                        <td>{request.approvedBy}</td>
                        <td>{request?.Quotation?.name}</td>
                        <td>{formatDate(request.approvedDate)}</td>
                        <td>{formatDate(request.createdAt)}</td>
                        <td className="actions">
                          <Link to={`/vm/purchase-orders/${request.id}`}>
                            <ViewIcon />
                          </Link>
                          &nbsp;&nbsp;
                          {request.status !== 'HIDDEN' ? (
                            <span onClick={(e) => handleShowModal(e, request.id)} className="edit-icon">
                              <EditIcon />
                            </span>
                          ) : (
                            ''
                          )}
                          &nbsp;&nbsp;
                          {request.status !== 'HIDDEN' ? (
                            <Link
                              to="/"
                              className="delete"
                              onClick={(e) => handleShowConfirmModal(e, request.id, request.vehicleRequestId)}
                            >
                              <DeleteIcon />
                            </Link>
                          ) : (
                            ''
                          )}
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </Table>
              <PaginationInPage
                currentPage={currentPage}
                setCurrentPage={setCurrentPage}
                totalRecords={totalRecords}
                TABLE_DEFAULT_LIMIT={TABLE_DEFAULT_LIMIT}
              />
            </div>
          </div>
        </div>
      </div>
      <Modal size="lg" show={showPurchaseModal} backdrop="static" keyboard={false} className="request-modal">
        <Modal.Header>
          <Modal.Title>Edit Purchase Order</Modal.Title>
          <button type="button" className="btn-close" aria-label="Close" onClick={handleCloseModal}></button>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Row>
              <Col xs={4}>
                <FloatingLabel controlId="floatingInput" label="Purchase Number" className="mb-3">
                  <Form.Control
                    onChange={handleChangePurchaseOrder}
                    value={purchaseOrderForm?.purchaseNumber}
                    className="input"
                    name="purchaseNumber"
                    type="text"
                    placeholder="Purchase Number"
                    required
                  />
                </FloatingLabel>
              </Col>
              <Col xs={4}>
                <FloatingLabel controlId="floatingInput" label="Vehicle Name" className="mb-3">
                  <Form.Control
                    onChange={handleChangePurchaseOrder}
                    value={purchaseOrderForm?.vehicleName}
                    className="input"
                    name="vehicleName"
                    type="text"
                    placeholder="Vehicle Name"
                    required
                  />
                </FloatingLabel>
              </Col>
              <Col xs={4}>
                <FloatingLabel controlId="floatingInput" label="Amount" className="mb-3">
                  <Form.Control
                    onChange={handleChangePurchaseOrder}
                    value={purchaseOrderForm?.amount}
                    className="input"
                    name="amount"
                    type="text"
                    placeholder="Amount"
                    required
                  />
                </FloatingLabel>
              </Col>
            </Row>
            <Row className="mb-4">
              <Col xs={4}>
                <FloatingLabel controlId="floatingInput" label="Approved Date" className="mb-3">
                  <Form.Control
                    onChange={handleChangePurchaseOrder}
                    value={purchaseOrderForm?.approvedDate}
                    className="input"
                    name="approvedDate"
                    type="date"
                    placeholder="Approved Date"
                    required
                  />
                </FloatingLabel>
              </Col>
              <Col xs={4}>
                <FloatingLabel controlId="floatingInput" label="Approved By" className="mb-3">
                  <Form.Control
                    onChange={handleChangePurchaseOrder}
                    value={purchaseOrderForm?.approvedBy}
                    className="input"
                    name="approvedBy"
                    type="text"
                    placeholder="Name of the Approver"
                    required
                  />
                </FloatingLabel>
              </Col>
            </Row>
            <Row className="bottom-content">
              <Col xs={12}>
                <Alert.Heading>PO Documents</Alert.Heading>
                <hr />
              </Col>
              <Col xs={4}>
                <Form.Group controlId="formFile" className="mb-3 images-box">
                  <Form.Label>Document 1</Form.Label>
                  <Form.Control onChange={onChangeDocumentOne} required type="file" name="file1" aria-required="false" />
                  <p className="file-name">{purchaseOrderForm?.file1Name}</p>
                </Form.Group>
              </Col>
              <Col xs={4}>
                <Form.Group controlId="formFile" className="mb-3 images-box">
                  <Form.Label>Document 2</Form.Label>
                  <Form.Control onChange={onChangeDocumentTwo} required type="file" name="file2" aria-required="false" />
                  <p className="file-name">{purchaseOrderForm?.file2Name}</p>
                </Form.Group>
              </Col>
              <Col xs={4}>
                <Form.Group controlId="formFile" className="mb-3 images-box">
                  <Form.Label>Document 3</Form.Label>
                  <Form.Control onChange={onChangeDocumentThree} type="file" name="file3" aria-required="false" />
                  <p className="file-name">{purchaseOrderForm?.file3Name}</p>
                </Form.Group>
              </Col>
            </Row>
            <Button onClick={handleSubmit} type="submit" className="add-request-btn mt-4 mb-3 justify-content-center">
              Update
            </Button>
          </Form>
        </Modal.Body>
      </Modal>
      <Modal size="sm" show={showConfirmModel} backdrop="static" keyboard={false} className="request-modal">
        <Modal.Header className="bg-danger text-light py-2">
          <Modal.Title>Delete Purchase Order</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="d-flex justify-content-start">
            <img src={AlertIcon} />
            <p className="ps-3 mb-0">Are you sure? Action cannot be undone.</p>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <div className="btn-wrapper">
            <button onClick={handleCloseConfirmModal} className="btn app-btn-default btn-sm">
              Cancel
            </button>
            <button onClick={(e) => handleRemove(e, idToDeleted)} className="btn app-btn-danger btn-sm">
              Delete
            </button>
          </div>
        </Modal.Footer>
      </Modal>
    </React.Fragment>
  );
};

export default PurchaseOrderList;
